import { create } from "zustand";
import { persist } from "zustand/middleware";
import { LS_PROJECTS_LIST_CHAT_STORAGE } from "../shared/local-storage/keys";

export type TProjectsListChatMessage = {
  role: "user" | "assistant";
  content: string;
};

type TProjectsListChatState = {
  historyByOrg: Record<number, TProjectsListChatMessage[]>;
  getMessages: (organizationId: number | null) => TProjectsListChatMessage[];
  setMessages: (organizationId: number, messages: TProjectsListChatMessage[]) => void;
};

const EMPTY_MESSAGES: TProjectsListChatMessage[] = [];
const MAX_STORED_MESSAGES_PER_ORG = 60;

export const useProjectsListChatStore = create<TProjectsListChatState>()(
  persist(
    (set, get) => ({
      historyByOrg: {},
      getMessages: (organizationId) =>
        organizationId === null ? EMPTY_MESSAGES : get().historyByOrg[organizationId] ?? EMPTY_MESSAGES,
      setMessages: (organizationId, messages) =>
        set((state) => ({
          historyByOrg: { ...state.historyByOrg, [organizationId]: messages.slice(-MAX_STORED_MESSAGES_PER_ORG) }
        }))
    }),
    {
      name: LS_PROJECTS_LIST_CHAT_STORAGE,
      partialize: (state) => ({ historyByOrg: state.historyByOrg })
    }
  )
);
